"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const remoteCache = {};
function loadRemoteScript(url) {
    // Avoid reloading the same script within a given session.
    if (remoteCache[url]) {
        return remoteCache[url];
    }
    const loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.onload = () => {
            script.onload = null;
            resolve();
        };
        /* istanbul ignore next */
        script.onerror = () => {
            script.onerror = null;
            console.error(`Roo.url#loadScript: ${url} is not accessible.`);
            reject();
        };
        script.setAttribute('src', url);
        document.body.appendChild(script);
    });
    remoteCache[url] = loadPromise;
    return loadPromise;
}
exports.default = loadRemoteScript;
function clearRemoteCache() {
    Object.keys(remoteCache).forEach((url) => {
        delete remoteCache[url];
    });
}
exports.clearRemoteCache = clearRemoteCache;
